import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { ListItem } from 'components/Listing';

const StyledListing = styled.div`
  
`;

const List = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding-bottom: 2rem;
  list-style-type: none;
  margin-left: 0;
`;

export default class Listing extends Component {
  render() {
    const { posts } = this.props;
    // GraphQL query on index.jsx page limits to 4 posts
    return (
      <StyledListing>
        <List>
          {posts.map(post => {
            let categories = false;
            if (post.node.data.categories[0].category) {
              categories = post.node.data.categories.map(c => c.category.document[0].data.name);
            }
            return <ListItem key={post.node.uid} node={post.node} categories={categories} />;
          })}
        </List>
      </StyledListing>
    );
  }
}

Listing.propTypes = {
  posts: PropTypes.array.isRequired,
};
